// Register the custom attribute on the core/gallery block
wp.hooks.addFilter(
	'blocks.registerBlockType',
	'pwd/gallery-lightbox-attribute',
	(settings, name) => {
		if (name !== 'core/gallery') return settings;

		return {
			...settings,
			attributes: {
				...settings.attributes,
				pwdLightbox: {
					type: 'boolean',
					default: false,
				},
			},
		};
	}
);

// Add the Inspector Controls toggle
wp.hooks.addFilter(
	'editor.BlockEdit',
	'pwd/gallery-link-toggle',
	(BlockEdit) => (props) => {
		if (props.name !== 'core/gallery') return wp.element.createElement(BlockEdit, props);

		const { Fragment, useEffect } = wp.element;
		const { InspectorControls } = wp.blockEditor;
		const { PanelBody, ToggleControl } = wp.components;

		// -------------------------------------------------------
		// Migration: if legacy linkTo:'media' is set, convert it
		// to pwdLightbox:true and clear linkTo back to 'none'
		// -------------------------------------------------------
		useEffect(() => {
			if (props.attributes.linkTo === 'media' && props.attributes.pwdLightbox !== true) {
				props.setAttributes({
					pwdLightbox: true,
					linkTo: 'none',
				});
			}
		}, []); // Empty dependency array = runs once on block load

		const isLightbox = props.attributes.pwdLightbox === true;

		return (
			wp.element.createElement(Fragment, null,
				wp.element.createElement(BlockEdit, props),
				wp.element.createElement(InspectorControls, null,
					wp.element.createElement(PanelBody, { title: 'Lightbox Settings', initialOpen: true },
						wp.element.createElement(ToggleControl, {
							label: 'Gallery images all open in lightbox',
							checked: isLightbox,
							onChange: (value) => {
								props.setAttributes({ pwdLightbox: value });
							}
						})
					)
				)
			)
		);
	}
);